module.exports = __webpack_public_path__ + "img/anuenciaConsulta.679f3069.jpg";